import styled from "styled-components"
import Success from "@irati/ui/src/Success"

export const StyledSuccess = styled(Success)`
  margin-top: 25px;
`
export const ButtonWrapper = styled.div`
  margin-top: 25px;
`
export const StyledError = styled.div`
  text-align: center;
  margin-top: 10px;
`
